import {_} from 'lodash';
import {RulePart} from "./RulePart";
import {IRulePartParams} from "./index";
import {IRuleset} from "../../../../index";
import {IComboboxOptions_Ruleset} from "../../../combobox/ruleset";
import {lm} from "../../../../appContext";
import {MutableRuleAbstract} from "./MutableRuleAbstract";
import argumentHtml from './argument.html?raw';

export let template = argumentHtml;

export class viewModel extends RulePart {

    constructor(params: IRulePartParams) {
        super(params);

        this.kosub.subscribe(this.ruleMutable.argumentoperator, () => {
            const operator = this.ruleMutable.argumentoperator();
            if (!operator) {
                return;
            }
            const argumentType = this.ruleMutable.availableData.getArgumentType(operator);
            if (argumentType == "bool") {
                this.ruleMutable.argument("");
            }
        });
        
    }
    private onRulesetComboboxInit(rs: IRuleset) {
        if (!rs) {
            this.ruleMutable.argument('')
        }
    }
    
    private getComboboxParams_ruleset(obj: MutableRuleAbstract): IComboboxOptions_Ruleset {
        return {
            comboboxOptions: {
                prepareData: {
                    filter: (o: IRuleset) => o.objecttype.id == this.objectType().id && o.id != obj.availableData.ruleset.data.$original.id,
                    sort: arr => _.sortBy(arr, (o: IRuleset) => o.name.toLowerCase()),
                },
                inputAttrs: {placeholder: lm.t('choose ruleset|td')},
                initialMatch: o => o.id == obj.argument(),
                option: {label: o => o.name},
                onSelect: o => obj.argument(o ? o.id : null),
            },
            objectTypeIds: this.objectType().id,
            canChangeObjectType: false,
        }
    }
}
